module.exports = __webpack_public_path__ + "static/media/Portal_Logo_Small.58e1f995.svg";